/* The chat layout preference — ONE place that knows the stored key, the
 * legal values, the migration, and how a value maps onto the document.
 * Read at boot (main.jsx, before first paint, so nothing flickers) and on
 * every change (SettingsPage). Nothing else should touch the attributes.
 *
 *   'clean'   → the shell's ALIGNED register with no row marked as your
 *               own, so every message sits on the left in one style: no
 *               hairlines, same-sender runs share one head.
 *   'bubbles' → the aligned geometry with synapse's bubble fills layered on
 *               top (app-side, [data-bubble-mode]).
 *
 * data-chat-layout is synapse's preference; data-chat-register is the SHELL's
 * contract (@ofself/shell/chat.css §6). This function is the only mapping
 * between them.
 */
export const CHAT_LAYOUTS = ['clean', 'bubbles']
export const DEFAULT_CHAT_LAYOUT = 'clean'

const KEY = 'paradigm_chat_layout'
const LEGACY_KEY = 'paradigm_bubble_mode'

/** The stored preference, migrating the legacy bubble toggle and any value
 *  from a retired layout. Never returns anything outside CHAT_LAYOUTS. */
export function readChatLayout() {
  const stored = localStorage.getItem(KEY)
  if (CHAT_LAYOUTS.includes(stored)) return stored
  // Legacy: a bare on/off bubble toggle. On means bubbles; anything else
  // (off, or never set) lands on the default.
  return localStorage.getItem(LEGACY_KEY) === 'true' ? 'bubbles' : DEFAULT_CHAT_LAYOUT
}

/** Put a layout on the document (and persist it). Safe to call before React
 *  mounts. */
export function applyChatLayout(layout) {
  const value = CHAT_LAYOUTS.includes(layout) ? layout : DEFAULT_CHAT_LAYOUT
  const root = document.documentElement
  root.setAttribute('data-chat-layout', value)
  // Both layouts speak the shell's aligned register — bubbles only adds fills.
  root.setAttribute('data-chat-register', 'aligned')
  if (value === 'bubbles') root.setAttribute('data-bubble-mode', 'true')
  else root.removeAttribute('data-bubble-mode')
  localStorage.setItem(KEY, value)
  localStorage.setItem(LEGACY_KEY, String(value === 'bubbles'))
  return value
}
